import { createSlice } from "@reduxjs/toolkit";

const DEBUG_SHOP_STORAGE_KEY = "debugShop";

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    isAdmin: false,
    adminRole: null,
    debugShop: sessionStorage.getItem(DEBUG_SHOP_STORAGE_KEY) || null,
  },
  reducers: {
    setAdminContext(state, action) {
      state.isAdmin = action.payload.isAdmin;
      state.adminRole = action.payload.adminRole;
    },
    setDebugShop(state, action) {
      state.debugShop = action.payload;
      sessionStorage.setItem(DEBUG_SHOP_STORAGE_KEY, action.payload);
    },
    clearDebugShop(state) {
      state.debugShop = null;
      sessionStorage.removeItem(DEBUG_SHOP_STORAGE_KEY);
    },
  },
});

export const adminActions = adminSlice.actions;
export default adminSlice.reducer;
